sharpen-empty {
  display: block;
  background-color: var(--color-gray-4);
  color: var(--color-gray-1);
  padding: var(--spacing-lg);
}